import actionCreatorFactory from 'typescript-fsa'
import {
  ResultPageWebModel, Subsidiary,
  UserLogin,
} from '@professocialApi/professocial-core-frontend-api/models/index'
import {
  CreateUserAccountRequest,
  DeleteUserAccountRequest,
  GetAllUsersRequest,
  GetUserAccountRequest,
  UnmountFacebookPageByUserRequest,
  UpdateUserAccountRequest,
} from '@professocialApi/professocial-core-frontend-api/apis/UserLoginRESTServiceApi'
import { ListSubsidiariesRequest } from '@professocialApi/professocial-core-frontend-api/apis/SubsidiaryRESTServiceApi'
import { SaveSuccess } from './accounts.reducer'
import { LoginAsRequest } from '@professocialApi/professocial-core-frontend-api/apis/AutorisationROApi'
import { UserAboSettings } from '@3m5/sm_publish-frontend-api/models'
import { GetAboSettingsForPageIdentifiersRequest } from '@3m5/sm_publish-frontend-api/apis/AboSettingsApi'
import {
  InitiateConnectOperationRequest,
  ForceDisconnectRequest
} from '@professocialApi/professocial-core-frontend-api/apis/SmPublishConnectApi'
import { InitiateConnectResponse, PageIdentifier } from '@professocialApi/professocial-core-frontend-api/models'
import { GetTokenForPageRequest } from '@professocialApi/professocial-core-frontend-api/apis/TmpAdminApi'

const actionCreator = actionCreatorFactory('ACCOUNTS')

/*
 * Actions
 */
export const setOnSuccess = actionCreator<SaveSuccess | null>('SET_ON_SUCCESS_INITIATED')

export const createUserAccountInitiated = actionCreator<CreateUserAccountRequest>('CREATE_USER_ACCOUNT_INITIATED')
export const createUserAccount = actionCreator.async<CreateUserAccountRequest, UserLogin>('CREATE_USER_ACCOUNT')

export const deleteUserAccountInitiated = actionCreator<DeleteUserAccountRequest>('DELETE_USER_ACCOUNT_INITIATED')
export const deleteUserAccount = actionCreator.async<DeleteUserAccountRequest, undefined>('DELETE_USER_ACCOUNT')

export const getAllUsersInitiated = actionCreator<GetAllUsersRequest>('GET_ALL_USERS_INITIATED')
export const getAllUsers = actionCreator.async<GetAllUsersRequest, ResultPageWebModel>('GET_ALL_USERS')

export const getUserAccountInitiated = actionCreator<GetUserAccountRequest>('GET_USER_ACCOUNT_INITIATED')
export const getUserAccount = actionCreator.async<GetUserAccountRequest, UserLogin>('GET_USER_ACCOUNT')

export const updateUserAccountInitiated = actionCreator<UpdateUserAccountRequest>('UPDATE_USER_ACCOUNT_INITIATED')
export const updateUserAccount = actionCreator.async<UpdateUserAccountRequest, UserLogin>('UPDATE_USER_ACCOUNT')

export const getAllSubsidiariesInitiated = actionCreator('GET_ALL_SUBSIDIARIES_INITIATED')
export const getAllSubsidiaries = actionCreator.async<undefined, Subsidiary[]>('GET_ALL_SUBSIDIARIES')

export const listSubsidiariesInitiated = actionCreator<ListSubsidiariesRequest>('LIST_SUBSIDIARIES_INITIATED')
export const listSubsidiaries = actionCreator.async<ListSubsidiariesRequest, Subsidiary[]>('LIST_SUBSIDIARIES')

export const unmountFacebookPageByUserInitiated = actionCreator<UnmountFacebookPageByUserRequest>('UNMOUNT_FACEBOOK_PAGE_BY_USER_INITIATED')
export const unmountFacebookPageByUser = actionCreator.async<UnmountFacebookPageByUserRequest, undefined>('UNMOUNT_FACEBOOK_PAGE_BY_USER')

export const forceDisconnectInitiated = actionCreator<ForceDisconnectRequest>('FORCE_DISCONNECT_INITIATED')
export const forceDisconnect = actionCreator.async<ForceDisconnectRequest, undefined>('FORCE_DISCONNECT')

export const initiateFacebookConnectInitiated = actionCreator<InitiateConnectOperationRequest>('INITIATE_FACEBOOK_CONNECT_INITIATED')
export const initiateFacebookConnect = actionCreator.async<InitiateConnectOperationRequest, InitiateConnectResponse>('INITIATE_FACEBOOK_CONNECT')

export const loginAsInitiated = actionCreator<LoginAsRequest>('LOGIN_AS_INITIATED')
export const loginAs = actionCreator.async<LoginAsRequest, undefined>('LOGIN_AS')

export const getAboSettingsForPageIdentifiersInitiated = actionCreator<GetAboSettingsForPageIdentifiersRequest>('GET_ABO_SETTINGS_FOR_PAGE_IDENTIFIERS_INITIATED')
export const getAboSettingsForPageIdentifiers = actionCreator.async<GetAboSettingsForPageIdentifiersRequest, UserAboSettings[]>('GET_ABO_SETTINGS_FOR_PAGE_IDENTIFIERS')

export const getPageIdentifiersForUserInitiated = actionCreator<void>('GET_PAGE_IDENTIFIERS_FOR_USER_INITIATED')
export const getPageIdentifiersForUser = actionCreator.async<void, PageIdentifier[]>('GET_PAGE_IDENTIFIERS_FOR_USER')

export const getTokenForPageInitiated = actionCreator<GetTokenForPageRequest>('GET_TOKEN_FOR_PAGE_INITIATED')
export const getTokenForPage = actionCreator.async<GetTokenForPageRequest, string>('GET_TOKEN_FOR_PAGE')

